import { PdfHeader } from "../../components";
import { formatPhoneNumber } from "../../utils/appUtils";
import dayjs from "dayjs";

const SingleComplaintReport = ({ complaintIdData }) => {
    const data = complaintIdData?.data;
    return <div className="singleComplaintReport">
        <PdfHeader pdfName="Complaint Report" />
        <div style={{ padding: "10px" }}>
            <div>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
                    <h3 className="lawyerInfo-heading" > Cons. Details</h3>
                    <div style={{ display: "flex" }}>
                        {
                            data?.consultationDetails?.consultationStatus === "COMPLETED" ? <div className="success-status"><p style={{ padding: "0px 5px" }}>Completed</p></div> : <div style={{ padding: "0px 5px" }}><p></p></div>
                        }
                        {
                            data?.recordDetail ? <div className="success-status"><p>Recorded</p></div> : <div className="danger-status"><p style={{ fontSize: "14px" }}>Not recorded</p></div>
                        }
                    </div>

                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Cons. Date</small>
                        <h3 className="lawerInfo-detail">{data?.consultationDetails?.consultationDate ? dayjs(data?.consultationDetails?.consultationDate).format("DD-MM-YYYY") : "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Cons. ID</small>
                        <h3 className="lawerInfo-detail">{data?.consultationDetails?.consultationNo || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Customer ID</small>
                        <h3 className="lawerInfo-detail">{data?.consultationDetails?.customerNo || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Start Time</small>
                        <h3 className="lawerInfo-detail">{data?.consultationDetails?.consultationStartTime ? dayjs(data?.consultationDetails?.consultationStartTime, "HH:mm")?.format("hh:mm A") : "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">End Time</small>
                        <h3 className="lawerInfo-detail">{data?.consultationDetails?.consultationEndTime ? dayjs(data?.consultationDetails?.consultationEndTime, "HH:mm")?.format("hh:mm A") : "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div style={{ padding: "10px 0px" }}>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
                    <h3 className="lawyerInfo-heading" >Complaint Details</h3>
                    {
                        data?.complaintStatus === "PENDING" ? <div className="pending-status" style={{ margin: 0 }}><p style={{ padding: "0px 5px" }}>Pending</p></div> : <div className="success-status"><p style={{ padding: "0px 5px" }}>Completed</p></div>
                    }
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Complaint Date</small>
                        <h3 className="lawerInfo-detail">{data?.complaintDate ? dayjs(data?.complaintDate)?.format("DD-MM-YYYY") : "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Complaint ID</small>
                        <h3 className="lawerInfo-detail">{data?.complaintNo || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                    <h3 className="lawyerInfo-heading" >Complaint Description</h3>
                </div>
                <p>{data?.complaintDescription || "Nil"}</p>
            </div>
            <div>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                    <h3 className="lawyerInfo-heading" >Raised By</h3>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Name</small>
                        <h3 className="lawerInfo-detail">{data?.raisedByName || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Rasied By ID</small>
                        <h3 className="lawerInfo-detail">{data?.raisedByNo || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail">{formatPhoneNumber(data?.raisedByMobileNumber) || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Mail ID</small>
                        <h3 className="lawerInfo-detail">{data?.raisedByEmail || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                    <h3 className="lawyerInfo-heading" >Against By</h3>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Name</small>
                        <h3 className="lawerInfo-detail">{data?.againstByName || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Against By ID</small>
                        <h3 className="lawerInfo-detail">{data?.againstByNo || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail">{formatPhoneNumber(data?.againstByMobileNumber) || "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">Mail ID</small>
                        <h3 className="lawerInfo-detail">{data?.againstByEmail || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div>
                <div style={{ padding: "10px 0px" }}>
                    <h2 className="lawyerInfo-heading" style={{ fontSize: "20px" }}>Action Taken</h2>
                </div>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                    <h3 className="lawyerInfo-heading" >Raised By</h3>
                </div>
                <div>
                    <p>{data?.actionItemRaisedBy || "Nil"}</p>
                </div>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                    <h3 className="lawyerInfo-heading" >Against By</h3>
                </div>
                <p>{data?.actionItemAgainstBy || "Nil"}</p>
            </div>
        </div>
    </div>
};
export default SingleComplaintReport